import { Tooltip } from "@mui/material";
import DarkModeCopyIcon from "assets/img/svg/darkModeCopyIcon.svg?react";
import React, { useEffect, useRef, useState } from "react";
import { fallbackCopyTextToClipboard } from "../../utils";
import "./styles.scss";

interface CopyButtonProps {
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
  displayValue?: string | React.ReactNode | React.ReactElement;
  onClick?: () => void;
  value: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  ariaLabel = "Copy to clipboard",
  className = "",
  disabled,
  displayValue,
  onClick,
  value,
}) => {
  const [clicked, setClicked] = useState(false);
  const resetTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (resetTimerRef.current !== null) clearTimeout(resetTimerRef.current);
    },
    [],
  );

  const handleClick = () => {
    if (disabled) return;
    fallbackCopyTextToClipboard(value);
    setClicked(true);
    onClick?.();
    if (resetTimerRef.current !== null) clearTimeout(resetTimerRef.current);
    resetTimerRef.current = setTimeout(() => {
      resetTimerRef.current = null;
      setClicked(false);
    }, 1000);
  };

  return (
    <div className={`${className} flex gap-2`}>
      <Tooltip open={clicked} title="Copied to clipboard!">
        <button
          aria-label={ariaLabel}
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
          type="button"
        >
          <DarkModeCopyIcon
            className={`CopyButton-Icon ${clicked ? "CopyButton-IconClicked" : ""}`}
          />
        </button>
      </Tooltip>
      <div>{displayValue || value}</div>
    </div>
  );
};

export default CopyButton;
